export enum FeatureFlags {
    AmsterdamOverspanningen = 'amsterdamOverspanningen',
    Image360 = '360Image',
    Cra = 'CRA',
    /**
     * Uploading UT measurements from a CSV file at a data point. Not enabled on production yet.
     * The value is matched case-sensitively against ZXY_FEATURE_FLAGS, so write it exactly like this.
     */
    UtCsvImport = 'UtCsvImport',
}
